// Grit logo. SVG recreation of Kenny's mark (orange G + speed streaks) for in-app
// use; the real PNG replaces the PWA icons in public/.

export function logoMark({ size = 34 } = {}) {
  const stroke = 'rgb(var(--brand))'; // per-person colour (style attribute: SVG attributes can't read CSS variables)
  return `
    <svg width="${size}" height="${Math.round(size * 0.78)}" viewBox="0 0 34 26" aria-label="Grit">
      <line x1="1" y1="10" x2="13" y2="10" style="stroke:${stroke}" stroke-width="2.8" stroke-linecap="round"/>
      <line x1="2" y1="14" x2="12" y2="14" style="stroke:${stroke}" stroke-width="2.2" stroke-linecap="round"/>
      <line x1="4" y1="18" x2="11" y2="18" style="stroke:${stroke}" stroke-width="1.7" stroke-linecap="round"/>
      <path d="M29 8 A9 9 0 1 0 29 18 L29 14 L21 14" fill="none" style="stroke:${stroke}" stroke-width="4" stroke-linecap="round"/>
    </svg>
  `;
}

export function wordmark({ onDark = true } = {}) {
  const base = onDark ? '#FFFFFF' : '#1A1A1A';
  return `
    <span class="font-bold tracking-tight text-[18px]" style="color:${base}">
      GR<span style="color:rgb(var(--brand))">I</span>T
    </span>
  `;
}

export function logoHeader({ onDark = true } = {}) {
  return `
    <div class="flex items-center gap-2">
      ${logoMark({ size: 30 })}
      ${wordmark({ onDark })}
    </div>
  `;
}
